
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.356 13.644a.79.79 0 010 1.152.818.818 0 01-1.152 0 4.06 4.06 0 010-5.737l2.872-2.872a4.06 4.06 0 015.737 0 4.06 4.06 0 010 5.737l-1.209 1.209a5.601 5.601 0 00-.325-1.964l.382-.39a2.42 2.42 0 000-3.44 2.42 2.42 0 00-3.44 0l-2.865 2.864a2.42 2.42 0 000 3.441zm2.288-3.44a.818.818 0 011.152 0 4.06 4.06 0 010 5.737l-2.872 2.872a4.06 4.06 0 01-5.737 0 4.06 4.06 0 010-5.737l1.209-1.209a5.68 5.68 0 00.324 1.972l-.38.381a2.42 2.42 0 000 3.44 2.42 2.42 0 003.44 0l2.864-2.864a2.42 2.42 0 000-3.44.79.79 0 010-1.152z","fill":"currentColor"}})])
          )
        }
      }
    